export const ADD_USER_WISHLIST = "ADD_USER_WISHLIST";
export const ADD_USER_BUY = "ADD_USER_BUY";
export const ADD_USER_DONATE = "ADD_USER_DONATE";
export const ADD_USER_EXCHANGE = "ADD_USER_EXCHANGE";
export const ADD_USER_ORDERS = "ADD_USER_ORDERS";
export const ADD_USER_RESERVES = "ADD_USER_RESERVES";
export const PRODUCT_LOADING = "PRODUCT_LOADING";
export const USER_DETAILS = "USER_DETAILS";
export const USER_LOADING = "USER_LOADING";
export const EDIT_ADDRESS = "EDIT_ADDRESS";
export const EDIT_IMAGE_SUCCESS = "EDIT_IMAGE_SUCCESS";
